import React from 'react';
import GeneralConfiguration from './GeneralConfiguration';
import {Grid, Row, Col, Nav, NavItem, Tab, Panel} from 'react-bootstrap';
import Parse from 'parse';


class Configuration extends React.Component {
    currentUser = Parse.User.current();
  
    constructor() {
        super();
        this.state ={
            userName: "",
            isLoading: false,
            userPreferences: null,
        };
    }

    componentDidMount= async () => {
        if(this.currentUser === null){
            console.error('Not user logged');
            this.props.history.push( `/pages/log-out`)
            return;
        }

        this.setState({userName: this.currentUser.get("name")});
    }

    render() {
        const {userName, isLoading} = this.state;
        
        let loading = isLoading ? 
            <div className="loadingScreen">
                <div className="lds-dual-ring"></div>
            </div> 
            : 
            null;


        return (
            <Grid>
            {loading}
            <div className="vertical-separator-24px"></div>
                <Row>
                    <Col md={10} mdOffset={1}>
                        <Panel>
                            <Panel.Body>
                                <h3>{userName}</h3>
                                <Tab.Container id="tabs-with-icons" defaultActiveKey="info">
                                    <Row className="clearfix patient-form-container">
                                        <Col sm={12}>
                                            <Nav bsStyle="tabs">
                                                <NavItem eventKey="info">
                                                    <i className="fa fa-cog"></i><span className="hidden-xs">Configuración general de la cuenta</span>
                                                </NavItem>
                                            </Nav>
                                        </Col>
                                        <Col sm={12}>
                                            <Tab.Content animation>
                                                <Tab.Pane eventKey="info">
                                                    <Row>
                                                        <Col md={10} mdOffset={1}>
                                                            <GeneralConfiguration
                                                                user={this.currentUser}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Col>
                                    </Row>
                                </Tab.Container>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </Grid>
        )
    }
}

export default Configuration;



// WEBPACK FOOTER //
// ./src/views/Account/Configuration/Configuration.js